import { SVGFilterStatus } from 'components/maps';

const OutlineFilter: React.FunctionComponent = () => {
  return (
    <filter id={`${SVGFilterStatus.OUTLINE}`}>
      <feColorMatrix
        values='0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 1 0'
      />
      <feMorphology operator='dilate' radius={10} result='outlineMorph' />
      <feMerge>
        <feMergeNode in='outlineMorph' />
        <feMergeNode in='SourceGraphic' />
      </feMerge>
    </filter>
  );
};

export default OutlineFilter;
